$(document).ready(function(){
    language();
    swiper();
    quantitySelector();
    accordion();
});


function language(){
    $( "#lang" ).on( "click", function() {
        console.log('click');
        $( "#lang_list" ).toggleClass( "d-block" );
    } );
}



function swiper(){
    var swiper = new Swiper(".mySwiper", {
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

function quantitySelector(){
    $('[data-quantity-selector]').each(function(){
        qSelector(this);
    });

    function qSelector(el){
        var input = $(el).find('[data-quantity-input]');
        var minus = $(el).find('[data-quantity-minus]');
        var plus = $(el).find('[data-quantity-plus]');

        $(input).on('input', function(){
        setValue($(this).val());
        });
        
        $(minus).on('click', function(){
            console.log('minus');
        setValue($(input).val(), -1);
        });
        
        $(plus).on('click', function(){
        setValue($(input).val(), 1);
        console.log('plus');
        });

        function setValue(str, add=0){
        try{
            var val = parseInt(str);
            if(!val || val <= 0 || val == NaN){
            $(input).val(1);
            } else {
            if(add != 0)
                val = val + add;
            if(val > 0)
                $(input).val(val);
            }
        } catch(e){
            $(input).val(1);
        }
        }
    }
}


function accordion(){
    $('#accordion').find('.accordion-toggle').click(function(){
        var isActive = $(this).hasClass("active");
            $('.accordion-toggle').removeClass('active')
        if (!isActive) {
        $(this).toggleClass('active');
        }
            
        $(this).next().slideToggle('fast');     
        //Hide the other panels
        $(".accordion-content").not($(this).next()).slideUp('fast');
    });
}